module.exports = __webpack_public_path__ + "static/media/brand01.e72730f1.png";